import styled from 'styled-components';
import { Box } from '../layout';

export default styled(Box)<{ cancelled: boolean }>`
  ${({ theme, cancelled }) =>
    cancelled
      ? `
    &::before {
      border-top: solid 3px ${theme.primary};
      content: '';
      position: absolute;
      left: 0px;
      right: -14px;
      bottom: 0px;
      z-index: 1;
      transform: rotate(-40deg);
      transform-origin: 0% 0%;
    }
  `
      : ``}
`;
